// AuthContext.ts — apenas o React context + types.
// Mantido isolado para satisfazer react-refresh/only-export-components
// (Fast Refresh exige arquivos com apenas componentes para HMR limpo).

import { createContext } from 'react';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthUser {
  username: string;
  email: string;
  name?: string;
  /** URL de foto vinda do IdP (Google `picture` claim, se mapeado). */
  picture?: string;
  groups: string[];
}

export interface AuthContextValue {
  status: AuthStatus;
  user: AuthUser | null;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
